export const locale = {
  am: 'AM',
  pm: 'PM',
  hours: 'hours',
  minutes: 'minutes',
};
